<template>
	<div class="statisticalAnalysis disBetween">
		<div class="statisticalLeft">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">今日统计</span>
				</div>
			</div>
			<div class="listBox">
				<div class="contentBox scrollContBox">
					<ul ref="scrollview" class="scrollUl disAround">
						<li class="scrollLi disStart">
							<div class="imgBox img5"></div>
							<div class="itemBox ">
								<div class="valueBox">
									服务次数
								</div>
								<div class="valueBox">
									<span>{{recordObj.totalServiceNum}}</span>次
								</div>
							</div>
						</li>
						<li class="scrollLi disStart">
							<div class="imgBox img51"></div>
							<div class="itemBox ">
								<div class="valueBox">
									正常次数
								</div>
								<div class="valueBox">
									<span class="green">{{recordObj.normalServiceNum}}</span>次
								</div>
							</div>
						</li>
						<li class="scrollLi disStart scrollLiAct" @click="activeClick">
							<div class="imgBox img52"></div>
							<div class="itemBox ">
								<div class="valueBox">
									异常次数
								</div>
								<div class="valueBox">
									<span class="red">{{recordObj.abnormalServiceNum}}</span>次
								</div>
							</div>
						</li>
						<li class="scrollLi disStart">
							<div class="imgBox img53"></div>
							<div class="itemBox " v-if="$serviceProviderId">
								<div class="valueBox">
									实际营收
								</div>
								<div class="valueBox">
									<span>{{recordObj.realConsumeAmount}}</span>元
								</div>
							</div>
							<div class="itemBox " v-else>
								<div class="valueBox">
									营收
								</div>
								<div class="valueBox">
									<span>{{recordObj.realConsumeAmount}}</span>元
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<el-dialog title="异常记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation"
			width="90%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disStart">
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.orderId" placeholder="请输入订单号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.transactionId" placeholder="请输入交易单号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityEquipmentNo"
							@change="changeCommunityEquipmentPort" placeholder="请输入设备编号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityEquipmentPort" type="Number"
							:disabled="!searchObj.communityEquipmentNo" placeholder="请输入端口"></el-input>
					</div>

					<div class="myinputBox">
						<el-select clearable v-model="searchObj.orderStatus" slot="prepend" placeholder="请选择充电情况">
							<el-option v-for="(item,inx) in orderStatusList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox" v-if="!($serviceProviderId)">
						<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
							<el-option v-for="(item,inx) in serviceList" :key="inx" :label="item.serviceProviderName"
								:value="item.serviceProviderId"></el-option>
						</el-select>
					</div>

					<div class="myinputBox">
						<el-input clearable v-model="searchObj.loginId" placeholder="请输入用户名"></el-input>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
					</div>

					<el-button type="success" @click="getoperationData">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" stripe style="width: 100%" >
						<el-table-column type="index" label="序号" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="userName" label="用户名">
							<template slot-scope="scope">
								<span v-if="scope.row.cardUserName">{{scope.row.cardUserName}}</span>
								<span v-else>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="cardNumber" label="卡号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="充电地址">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentPort" label="端口" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="startTime" label="充电时间" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="payType" label="支付方式">
							<template slot-scope="scope">
								<span>{{scope.row.payType==1?"微信支付":scope.row.payType==2?"余额支付":scope.row.payType==3?"电卡支付":""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderStatus" label="充电情况">
							<template slot-scope="scope">
								<span>{{scope.row.orderStatus==1?"充电中":scope.row.orderStatus==2?"充电结束":scope.row.orderStatus==0?"未充电":""}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="communityEquipmentPortPower" label="最大功率(W)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="timeStr" label="实际时长"></el-table-column>
						<el-table-column show-overflow-tooltip prop="realConsumeAmount"
							label="实际营收(元)"></el-table-column>
						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
									<div class="pupBox">
										<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
									</div>
									<div slot="reference" class="itemRight listIcon"></div>
								</el-popover>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="mydialogTitle" center class="mydialog" :visible.sync="dialogVisible1" width="70%">
			<div class="dialogBox ">
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>交易单号：{{creatObj.transactionId}}</span>
						<span>订单号：{{creatObj.orderId}}</span>
						<span>用户名：{{creatObj.loginId}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>设备编号：{{creatObj.communityEquipmentNo}}</span>
						<span>端口：{{creatObj.communityEquipmentPort}}</span>
						<span>所属社区：{{creatObj.communityName}}</span>

					</div>
					<div class="itemBox itemBox1 disStart">
						<span>充电地址：{{creatObj.communitySiteName}}</span>
						<span>运营商：{{creatObj.equipmentServiceProvider}}</span>
						<span>充电时间：{{creatObj.startTime}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>结束时间：{{creatObj.realEndTime}}</span>
						<span>充电时长(小时)：{{creatObj.rechargeTime}}</span>
						<span>充电最大功率(W)：{{creatObj.communityEquipmentPortPower}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>实际时长：{{creatObj.timeStr}}</span>
						<span>充电金额(元)：{{creatObj.orderAmount}}</span>
						<span>退款(元)：{{creatObj.returnConsumeAmount}}</span>

					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>实际营收(元)：{{creatObj.realConsumeAmount}}</span>
						<span>充电情况：
							<span
								:class="creatObj.orderStatus==1?'green':creatObj.orderStatus==2?'red':creatObj.orderStatus==0?'grey':''">{{creatObj.orderStatus==1?"充电中":creatObj.orderStatus==2?"充电结束":creatObj.orderStatus==0?"未充电":""}}</span>
						</span>
						<span>结束理由：{{creatObj.endReason}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">

						<span>退款理由：{{creatObj.refundReason}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer diabtnBox">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	import {
		timestampToDate,
		timestampToyesterdayDate
	} from "@/assets/js/common.js"
	export default {
		name: "statisticalAnalysis",
		data() {
			return {
				recordObj: {
					avgChargeTime: "",
					avgConsumption: "",
					chargeNum: "",
					chargeRevenue: "",
					chargeTime: "",
					errorServiceNum: "",
					normalServiceNum: "",
					serviceNum: "",
				},
				loading: false,
				NOfalse: false,
				loading2: false,
				dialogOperation: false,
				OperationInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
					searchData: [],
					payType: "",
					orderId:"",
					rechargeType: null, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: timestampToDate(new Date()), //开始时间
					endTime:timestampToDate(new Date()) //结束时间
				},
				orderStatusList: [{
						text: "未充电",
						value: 0
					},
					{
						text: "充电中",
						value: 1
					},
					{
						text: "充电结束",
						value: 2
					}
				],
				serviceList: [],
				mydialogTitle: "充电记录",
				dialogVisible1: false,
				creatObj: {},
				operationData: []
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
				this.selectParamConfigByCode()
			})
		},
		methods: {
			getData() {
				this.$api.todayStatistics({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "recordObj", res.obj || {})
					}
				})
			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})

			},
			changeCommunityEquipmentPort(e) {
				if (e) {

				} else {
					this.$set(this.searchObj, "communityEquipmentPort", "")
				}
			},
			activeClick(n) {
				this.loading = true
				this.getListData()
			},
			getListData() {
				this.loading2 = true
				let obj={
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
					communityName: this.searchObj.communityName,
					communitySiteId: this.searchObj.communitySiteId,
					search: this.searchObj.search, //用户名称
					orderStatus: this.searchObj.orderStatus,
					orderId: this.searchObj.orderId,
					loginId: this.searchObj.loginId,
					refundFlag:3,
					transactionId: this.searchObj.transactionId,
					cardNumber: this.searchObj.cardNumber,
					communityEquipmentPort: this.searchObj.communityEquipmentPort,
					communityEquipmentNo: this.searchObj.communityEquipmentNo, //设备编号
					serviceProviderId: this.searchObj.serviceProviderId, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime, //结束时间
					payType: "", //结束时间
				}
				this.$api.listRechargeRecord(obj).then((res)=>{
					if(res.returnCode==200){
						this.dialogOperation = true
						this.loading2 = false
						this.$nextTick(() => {
							this.$set(this, "operationData", res.obj.list || [])
							this.$set(this.OperationInfo, "total", res.obj.total || 0)
						})
					}
				})
			},
			getoperationData() {
				this.$set(this.OperationInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.$nextTick(() => {
					this.getListData()
				})
			},
			handleCurrentChange(val) {
				this.$set(this.OperationInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getListData()
			},
			itemClick(obj, n) {
				let that = this
				this.$set(this, "creatObj", obj)
				if (n == 1) {
					this.$nextTick(() => {
						if (this.active == 1) {
							this.mydialogTitle = "卡充电记录(卡号：" + (obj.cardNumber || '-') + ")"
						} else {
							this.mydialogTitle = "充电记录"
						}
						this.dialogVisible1 = true
					})
				}

			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./statisticalAnalysis.scss";
</style>